module.exports = __webpack_public_path__ + "img/banner-quality-education.a5ecfbe2.png";